'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check, ClipboardCopy, Clipboard } from 'lucide-react';
import { useCallback, useEffect, useRef, useState } from 'react';
export const CopyButton = ({ content }) => {
    const timeoutRef = useRef(null);
    const [copied, setCopied] = useState(false);
    const handleCopy = useCallback(async () => {
        if (!copied && timeoutRef.current === null) {
            await navigator.clipboard.writeText(content);
            setCopied(true);
            timeoutRef.current = setTimeout(() => {
                setCopied(false);
                timeoutRef.current = null;
            }, 3000);
        }
    }, [content, copied]);
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    if (copied) {
        return (_jsx("div", { className: "copied-icon", children: _jsx(Check, { size: 16 }) }));
    }
    return (_jsx("button", { type: "button", "aria-label": "Copy to clipboard", className: "copy-button", onClick: handleCopy, children: _jsxs("div", { className: "icon-wrapper", children: [_jsx(Clipboard, { className: "icon icon-default", size: 16 }), _jsx(ClipboardCopy, { className: "icon icon-hover", size: 16 })] }) }));
};
